// extracted by mini-css-extract-plugin
export default {"searchList":"src-components-Tags-css__searchList--s0Hgb"};